'use client';

import type {FC} from 'react';

import {useQuery} from '@/sanity/loader/useQuery';

import {Footer} from '../../components/Footer';
import {SITE_SETTINGS_QUERY, type SiteSettingsQueryResult} from '../query';

import {footerPropsFromSiteSettingsFragment} from './query';

interface Props {
	initial: SiteSettingsQueryResult;
}

export const FooterContainerDraft: FC<Props> = ({initial}) => {
	const {data: siteSettings} = useQuery<SiteSettingsQueryResult>(initial, SITE_SETTINGS_QUERY);

	if (!siteSettings) {
		return null;
	}

	return <Footer {...footerPropsFromSiteSettingsFragment(siteSettings)} />;
};

export default FooterContainerDraft;
